/**
 * Turns an axios error into something worth showing a user.
 *
 * The API reports failures two ways: a single `{ error }` string, or
 * express-validator's `{ errors: [{ msg }] }` array for rejected input. Callers
 * should not have to know which one a given endpoint uses.
 */
export const apiErrorMessage = (err, fallback) => {
  const data = err?.response?.data;
  if (data?.error) return data.error;
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.map((item) => item.msg).filter(Boolean).join(' ');
  }
  return fallback;
};

export default apiErrorMessage;
